import { QuestionMarkCircleIcon } from "@heroicons/react/outline";

import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import { Toggle } from "@/components/Toggle";
import { Skeleton } from "@/components/ui/skeleton";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface VerboseModeToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  showVerboseMode?: boolean;
  isLoading?: boolean;
  tooltipContent?: string;
}

const VerboseModeToggle = ({
  enabled,
  onChange,
  showVerboseMode = true,
  isLoading = false,
  tooltipContent,
}: VerboseModeToggleProps) => {
  const isReadonly = useIsReadonly();
  if (!showVerboseMode) {
    return null;
  }

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-1">
        <span className="text-sm text-gray-700">Verbose Mode</span>
        {tooltipContent ? (
          <BasicTooltip content={tooltipContent}>
            <QuestionMarkCircleIcon className="h-4 w-4 text-gray-400" />
          </BasicTooltip>
        ) : null}
      </div>
      {isLoading ? (
        <Skeleton width={44} height={24} borderRadius={12} />
      ) : (
        <Toggle enabled={enabled} setEnabled={onChange} disabled={isReadonly} />
      )}
    </div>
  );
};

export default VerboseModeToggle;
